import { LocalizedParagraph, LocalizedTypography } from '@mews-commander/ui';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName, Stack } from '@optimus-web/core';
import { SecurityCard } from '../components/SecurityCard';
import { SecurityDataTestId } from '../utils/SecurityDataTestId';
import { useScimConfigurationQuery } from './useScimConfigurationQuery';
import { ConfigureScimPanel } from './ConfigureScimPanel/ConfigureScimPanel';
import { ScimStatusTag } from './ScimStatusTag';

export function ScimConfiguration() {
    const [scimConfigPanelProps, toggleConfigScimPanel] = useDialog();
    const hasOpenDialog = scimConfigPanelProps.active;

    const { data, isLoading } = useScimConfigurationQuery();
    const hasSetupActive = data?.id;

    return (
        <>
            <SecurityCard
                icon={IconName.Profile}
                variant={hasOpenDialog ? 'highlighted' : 'default'}
                isLoading={isLoading}
                data-test-id={SecurityDataTestId.ScimCard}
                action={
                    <Button
                        variant={hasSetupActive ? 'tertiary' : 'secondary'}
                        size="small"
                        onClick={toggleConfigScimPanel}
                        type="submit"
                    >
                        <LocalizedText textKey={hasSetupActive ? TextKey.Manage : TextKey.Configure} />
                    </Button>
                }
            >
                <Stack spacing="100" itemAlignment="center">
                    <LocalizedTypography textKey={TextKey.ScimProvisioning} textStyle="titleSmallStrong" as="div" />

                    <ScimStatusTag provisioningStatus={data?.provisioningStatus} />
                </Stack>
                <LocalizedParagraph align="left" textKey={TextKey.ScimProvisioningDescription} variant="secondary" />
            </SecurityCard>
            <ConfigureScimPanel data={data} loading={isLoading} {...scimConfigPanelProps} />
        </>
    );
}
